"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const breadcrumb_store_1 = require("./breadcrumb-store");
exports.breadcrumbServiceDefinition = {
    id: 'breadcrumb-service',
    create: () => {
        const breadcrumbStore = new breadcrumb_store_1.BreadcrumbStore();
        return {
            '1.0.0': (consumerId) => ({
                featureService: {
                    getBreadcrumbs: (requestedConsumerId) => breadcrumbStore.get(requestedConsumerId),
                    set: (breadcrumbs) => {
                        breadcrumbStore.update(consumerId, breadcrumbs);
                    },
                    listen: (listener) => breadcrumbStore.listen(consumerId, listener),
                },
                unbind: () => {
                    breadcrumbStore.unlisten(consumerId);
                },
            }),
        };
    },
};
//# sourceMappingURL=index.js.map